import { createFileRoute } from '@tanstack/react-router';

import { DevPage } from '@/pages';

export const Route = createFileRoute('/(app)/dev')({
  component: DevPage,
});
